import { apiClient } from '@/shared/lib/axios';
import { TownQuery } from '@/types/admin-town';
import { useParams } from 'react-router-dom';
import { useAdminCsvDownloadMutation } from './useAdminCsvDownloadMutation';

export const downloadTownsCsv = async (
  siteType: string,
  query?: TownQuery
): Promise<void> => {
  const response = await apiClient.get(`/admin/${siteType}/towns/csv`, {
    params: query,
    responseType: 'blob',
  });

  const blob = response.data;
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `towns${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const useDownloadTownsCsv = () => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useAdminCsvDownloadMutation<TownQuery | undefined>(query =>
    downloadTownsCsv(currentSite, query)
  );
};
